import React, { Component, Fragment } from 'react';
import SwitchTenantModalRuleForm from './SwitchTenantModalRuleForm';

export default class SwitchTenantModalRule extends Component {
  getPageOptions = () => {
    const { pages } = this.props;
    const pageOptions =
      pages.length > 0
        ? pages.map((item) => {
            return { value: '/' + item.slug, label: item.name };
          })
        : [];

    return pageOptions;
  };

  getRoleOptions = () => {
    const { roles } = this.props;
    const roleOptions =
      roles.length > 0
        ? roles.map((role, key) => {
            return { value: role.name, label: role.name };
          })
        : [];

    return roleOptions;
  };

  render() {
    const { createNewParamRow, params, collections, eventAction } = this.props;
    return (
      <Fragment>
        <div className="table-responsive">
          <table className="table table-sm table-bordered table-condensed">
            <thead style={{ fontWeight: 'bold' }}>
              <tr>
                <td className="text-left w-50">
                  {eventAction.name === 'switchSubTenant' ? 'Sub Tenant Role' : 'Tenant Role'}
                </td>
                <td className="text-left">Page</td>
              </tr>
            </thead>
            <tbody>
              {params.map((row) => {
                return (
                  <SwitchTenantModalRuleForm
                    paramRow={row}
                    key={row.id}
                    createNewRow={createNewParamRow}
                    collections={collections}
                    pageOptions={this.getPageOptions()}
                    roleOptions={this.getRoleOptions()}
                  />
                );
              })}
            </tbody>
          </table>
        </div>
      </Fragment>
    );
  }
}
